import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Help from "@/Help";
import FilterBtn from './FilterBtn.vue';
let Filters = class Filters extends Vue {
    constructor() {
        super(...arguments);
        this.expanded = false;
        //old responsive styles 
        //get filtersStylesObj() {
        //    if (this.resizable) {
        //        return {
        //            height: this.filtersHeight,
        //            maxWidth: '100%',
        //            width: this.filtersWidth
        //        } //respVal = "height: 120px !important; max-width:100%; width:100%;"
        //    }
        //    return {}
        //}
        //get filtersHeight() {
        //    if (!this.filtersExpanded) {
        //        return "168px"; //needs to match with .less #filters_wrap height
        //    }
        //    else {
        //        let height_filter_btn_px: number = 108;
        //        let width_filters_px: number = 400;
        //        if (this.resizable) {
        //            width_filters_px = this.windowWidth;//HERE
        //        }
        //        let filters_left_right_pad_total: number = 10;
        //        let num_filters_inc_toggle: number = 15;
        //        let width_filter_btn_px: number = 74;
        //        let number_filters_per_row: number = (width_filters_px - filters_left_right_pad_total) / width_filter_btn_px;
        //        let number_rows: number = Math.ceil(num_filters_inc_toggle / number_filters_per_row);
        //        let filters_expanded_height: number = ((number_rows * height_filter_btn_px) + filters_left_right_pad_total);
        //        return `${filters_expanded_height}px`;
        //    }
        //}
        //get filtersWidth() {
        //    return `${this.filtersWidthInner}px !important`;
        //}
        //get filtersWidthInner() {
        //    let width_filters_px: number = 400;
        //    if (this.resizable) {
        //        width_filters_px = this.windowWidth;
        //    }
        //    let filters_left_right_pad_total: number = 10;
        //    let width_filter_btn_px: number = 74;
        //    let number_filters_per_row: number = Math.floor((width_filters_px - filters_left_right_pad_total) / width_filter_btn_px);
        //    return (number_filters_per_row * width_filter_btn_px) + filters_left_right_pad_total;
        //}
    }
    clear() { this.$emit('clear'); }
    get awardFilters() {
        return this.filters.filter(i => i.isAward);
    }
    get miscFilters() {
        return this.filters.filter(i => !i.isAward);
    }
    toggle() { this.expanded = !this.expanded; }
    get toggleClass() {
        return this.expanded ? "expanded" : "";
    }
    get toggleTxt() {
        return this.expanded ? "Fewer" : "More Filters...";
    }
    get toggleTitle() {
        return `Show ${this.toggleTxt.toLowerCase()}`;
    }
    get filtersSelectedText() {
        return `${this.nofiltersSelected} filter${this.nofiltersSelected > 1 ? "s" : ""}`;
    }
    get anyFiltersAreSelected() {
        return this.nofiltersSelected > 0;
    }
    get nofiltersSelected() {
        return this.filtersSelected.length;
    }
    get filtersSelected() {
        return this.filters.filter(i => i.selected);
    }
    entailsInhibits(selected, entails, inhibits) {
        var toEntail = this.filters.filter(f => Help.contains(entails, f.id));
        var toInhibit = this.filters.filter(f => Help.contains(inhibits, f.id));
        if (selected) {
            toEntail.forEach(f => f.selectAndDisable());
            toInhibit.forEach(f => f.deselectAndDisable());
            if ((toEntail.length + toInhibit.length) > 0) {
                setTimeout(() => {
                    this.expanded = true;
                }, 500); //we use a timeout to allow the filtering to finish//isWaiting
            }
        }
        else {
            toEntail.forEach(f => f.reset());
            toInhibit.forEach(f => f.reset());
        }
    }
};
tslib_1.__decorate([
    Prop()
], Filters.prototype, "resizable", void 0);
tslib_1.__decorate([
    Prop()
], Filters.prototype, "windowWidth", void 0);
tslib_1.__decorate([
    Prop()
], Filters.prototype, "filters", void 0);
Filters = tslib_1.__decorate([
    Component({
        components: {
            FilterBtn,
        }
    })
], Filters);
export default Filters;
